export const annotationFilter = {
  filter: '',
};
